var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-click=\"$event.stopPropagation()\" class=\"c-modal is-active\"><div class=\"c-modal__body\">{{ vm.msg }}</div><div class=\"c-modal__footer text-right\"><button ng-click=\"vm.close(false)\" class=\"o-btn c-btn c-btn--secondary\">{{ 'no' | translate }}</button><button ng-click=\"vm.close(true)\" class=\"o-btn c-btn c-btn--outlined\">{{ 'yes' | translate }}</button></div></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/admin/bidPrices/confirmationModal.jade
 ** module id = 654
 ** module chunks = 0
 **/